import { storyblokEditable } from "@storyblok/react";
import Link from "next/link";

const TextButtonImage = ({ blok }) => (
  <div className="wrap">
  <div className="textbuttonimage-wrap flex inner-wrap" {...storyblokEditable(blok)}>
    <div className="textbuttonimage-wrap-content flex">
      <div className="textbuttonimage-content flex flex-col">
        <h2 className="text-2xl">{blok.subheadline}</h2>
        <img className="hide-mobile" src={blok.image.filename} alt={blok.image.alt} />
        <span>{blok.intro}</span>
        <p>{blok.text}</p>
        <div>
         {blok.link && (<Link href={blok.link} ><button>{blok.button}</button></Link>)} 
         {blok.linknewtab && (<Link target="_blank" href={blok.linknewtab} ><button>{blok.buttonnewtab}</button></Link> )}
        </div>
      </div>
      <div className="textbuttonimage-img hide-desktop ml-8">
        <img src={blok.image.filename} alt={blok.image.alt} />
      </div>
    </div>
  </div>
  </div>
);

export default TextButtonImage;
